<template>
    <transition name="dropdown">
        <div
            class="dropdown"
            v-on-clickaway="closeDropdown"
        >
            <slot />
        </div>
    </transition>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
    mixins: [clickaway],
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        closeDropdown() {
            if (this.isOpen) {
                this.$emit('close-dropdown');
            }
        },
    },
};
</script>
